import ArtTrackIcon from "@material-ui/icons/ArtTrack";
import ErrorIcon from "@material-ui/icons/Error";
import ListIcon from "@material-ui/icons/List";
import PersonIcon from "@material-ui/icons/Person";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";

export const residentEditTabDefinitions = [
  {
    key: "critical-information",
    title: "Critical Information",
    slug: "critical-information",
    icon: PersonIcon,
  },
  {
    key: "profile",
    title: "Profile",
    slug: "profile",
    icon: SupervisorAccountIcon,
    indicator: "support_network",
  },
  {
    key: "medications",
    title: "Medications",
    slug: "medications",
    icon: SupervisorAccountIcon,
  },
  {
    key: "care-plan",
    title: "Care Plan",
    slug: "care-plan",
    icon: ArtTrackIcon,
  },
  {
    key: "timeline",
    title: "Timeline",
    slug: "timeline",
    icon: ListIcon,
  },
  {
    key: "warnings",
    title: "Warnings",
    slug: "warnings",
    icon: ErrorIcon,
  },
  {
    key: "appointments",
    title: "Appointments",
    slug: "appointments",
    icon: ArtTrackIcon,
  },
  {
    key: "observations",
    title: "Observations",
    slug: "observations",
    icon: ErrorIcon,
  },
  // {
  //   key: "summaries",
  //   title: "Summaries",
  //   slug: "summaries",
  //   icon: ArtTrackIcon,
  // },
];

export const buildResidentEditTabPath = (id, slug) =>
  `/d/resident/edit/${id}/${slug}`;

export const buildResidentEditTabs = (id) =>
  residentEditTabDefinitions.map((tab) => ({
    ...tab,
    path: buildResidentEditTabPath(id, tab.slug),
  }));
